"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXArticle = exports.HTMLArticle = exports.HTMLArticleCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const paragraphItem_1 = require("./paragraphItem");
const supplNote_1 = require("./supplNote");
const common_1 = require("../common");
exports.HTMLArticleCSS = `
.article {
    clear: both;
}

`;
exports.HTMLArticle = (0, html_1.wrapHTMLComponent)("HTMLArticle", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const ArticleCaption = el.children.find(std.isArticleCaption);
    const ArticleTitle = el.children.find(std.isArticleTitle);
    const Paragraphs = el.children.filter(std.isParagraph);
    if (ArticleCaption) {
        blocks.push((react_1.default.createElement("div", { className: `article-caption indent-${indent + 1}`, ...(0, html_1.elProps)(ArticleCaption, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ArticleCaption.children, htmlOptions })))); /* >>>> INDENT >>>> */
    }
    const bodyBlocks = [];
    for (const [i, child] of Paragraphs.entries()) {
        if (i === 0 && ArticleTitle) {
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent, ArticleTitle: ArticleTitle, htmlOptions }));
        }
        else {
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent, htmlOptions }));
        }
    }
    for (const child of el.children) {
        if (std.isArticleCaption(child)
            || std.isArticleTitle(child)
            || std.isParagraph(child)) {
            continue;
        }
        else if (child.tag === "SupplNote") {
            bodyBlocks.push(react_1.default.createElement(supplNote_1.HTMLSupplNote, { el: child, indent: indent, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push((react_1.default.createElement("div", { className: "article-body" }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: "article", ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXArticle = (0, component_1.wrapDOCXComponent)("DOCXArticle", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const ArticleCaption = el.children.find(std.isArticleCaption);
    const ArticleTitle = el.children.find(std.isArticleTitle);
    const Paragraphs = el.children.filter(std.isParagraph);
    if (ArticleCaption) {
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent + 1}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ArticleCaption.children, docxOptions })))); /* >>>> INDENT >>>> */
    }
    const bodyBlocks = [];
    for (const [i, child] of Paragraphs.entries()) {
        if (i === 0 && ArticleTitle) {
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent, ArticleTitle: ArticleTitle, docxOptions }));
        }
        else {
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent, docxOptions }));
        }
    }
    for (const child of el.children) {
        if (std.isArticleCaption(child)
            || std.isArticleTitle(child)
            || std.isParagraph(child)) {
            continue;
        }
        else if (child.tag === "SupplNote") {
            bodyBlocks.push(react_1.default.createElement(supplNote_1.DOCXSupplNote, { el: child, indent: indent, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (bodyBlocks.length > 0) {
        blocks.push(react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(bodyBlocks)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=article.js.map